<template>
  <div class="assignment-manager-container">
    <div class="assignment-manager">
      <v-row class="header">
        <v-col cols="12">
          <h4>Device Assignment</h4>
        </v-col>
      </v-row>

      <!-- Org Selection Dropdown -->
      <v-row v-if="!hasSelectedOrg">
        <v-col cols="4">
           <v-autocomplete
            :items="orgName"
            class="org-select"
            label="Please select an organisation"
            item-text="name"
            outlined
            return-object
            @change="setSelectedOrg"
          />
        </v-col>
      </v-row>

      <!-- Component UI -->
      <v-row v-else>
        <!-- Install Tags List -->
        <v-col cols="5" fill-height>
          <InstallTags
            :selected-devices="selectedDevices" 
            @deviceSelectedForInstall="deviceSelectedForInstall"
          />
        </v-col>

        <!-- Action Buttons -->
        <v-col cols="1" class="d-flex fill-height align-center justify-center flex-column text-center">
          <v-btn class="ma-2" outlined large fab color="green">
            <v-icon @click="confirmAddQue">mdi-chevron-double-right</v-icon>
          </v-btn>
          <v-btn class="ma-2" outlined large fab color="red">
            <v-icon @click="deleteWrapper">mdi-chevron-double-left</v-icon>
          </v-btn>
          <v-btn class="ma-2" outlined large fab color="blue">
            <v-icon @click="deleteLastAction">mdi-refresh</v-icon>
          </v-btn>
        </v-col>

        <!-- Org Nodes -->
        <v-col cols="6">
          <NodePanel
            :org-id="selectedOrg.id"
            :orgs="orgName"
            @installTargetListSelected="setListTarget"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="auto"
          class="mr-auto"
        >
          <v-btn text class="ctrl-btn cancel" @click="closeWindow">
            CANCEL
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn text class="ctrl-btn submit" @click="toggleStatus">
            SUBMIT
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <SubmitAssignDialog 
      v-if="showSubmit"
      :actions="parsedActions"
      :org="selectedOrg.id"
      @closeSubmitAssign="cancelAddQue"
      @confirmAddToQue="finaliseQue"
      @updatingVehicleName="handleUpdatedVehicleName"
    />

    <AssignmentStatus 
      v-if="showStatus"
      :actions="parsedActions"
      :nodes="nodes"
      :org="selectedOrg.id"
      @closeAssignmentStatus="toggleStatus"
      @assignmentSubmited="resetActions"
      @closeAllAssignmentWindows="closeAllAssignmentWindows"
      @clearQue="clearQue"
    />
  </div>
</template>

<script>

import { Logger } from "aws-amplify"
const logger = new Logger("Device Assignment")


import InstallTags from './InstallTags.vue';
import NodePanel from './NodePanel.vue';
import SubmitAssignDialog from './SubmitAssignDialog.vue';
import AssignmentStatus from './AssignmentStatus.vue';

import { GetOrgTree } from '@/services/API.js';

export default {
  name: 'DeviceAssignment',
  components: {
    InstallTags,
    NodePanel,
    SubmitAssignDialog,
    AssignmentStatus
  },
  props: {
    orgs: {
      type: Array,
      required: true
    },
    selectedDevices: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedOrg: {},
      actions: [],
      devicesForInstallation: [],
      showSubmit: false,
      deviceDestination: [],
      initDeviceDestination: [],
      actionsQue: [],
      showStatus: false,
      nodes: {}
    }
  },
  computed: {
    orgName() {
      	const orgs = this.orgs.map((org) => ({
					name: org.name,
          id: org.id
				}));

        return orgs;
    },
    hasSelectedOrg() {
      if (this.selectedOrg.id) {
        return this.selectedOrg.id.length > 0 ? true : false;
      } else {
        return false;
      }
      
    },
    parsedActions() {
      let parsedActions = [];

      this.actionsQue.forEach(action => {
        action.devices.forEach(device => {
          let newAction = {};
          logger.info(device)
          newAction.id = device.hasOwnProperty('device_id') ? device.device_id : device.id;
          newAction.target = action.target[0].name ? action.target[0].name : action.target[0].vehicle_name;
          newAction.parent = this.returnParentId(action);
          newAction.status = 'init';
          newAction.isDir = action.target[0].dir;
          newAction.vehicleId = action.target[0].id;
          newAction.vehicle_type = action.target[0].icon ? 'Car' : action.target[0].vehicle_type;
          newAction.hasDevice = action.target[0].devices;
          newAction.install_tag = device.install_tag;
          newAction.updatedVehicleName = device.updatedVehicleName ? device.updatedVehicleName : device.install_tag;

          parsedActions.push(newAction);
        });
      });

      return parsedActions;
    },
  },
  watch: {
    deviceDestination(val) {
      if (val.length == 0) {
        this.deviceDestination = this.initDeviceDestination;
      }
    },
    actionsQue: {
      deep: true,
      handler(val) {
        logger.info('updating : ', val);
      }
    }
  },
  mounted() {
    window.EventBus.$on("deviceManagerSelection", this.handleDMSelection);
    window.EventBus.$on("initTargetDeviceManager", this.handleInitTarget);
  },
  methods: {
    returnParentId(data) {
      if (data.target[0].node) {
        return data.target[0].node;
      } else {
        return data.target[0].dir ? data.target[0].id : data.target[0].parentId;
      }
    },
    handleInitTarget(data) {
      logger.info('init target data : ', data);
      this.initDeviceDestination = data;
      this.deviceDestination = this.initDeviceDestination;
    },
    setListTarget(data) {
      this.deviceDestination = data;
    },
    toggleSubmitAssignDialog() {
      this.showSubmit = !this.showSubmit;
    },
    confirmAddQue() {
      this.addToQue();
      this.toggleSubmitAssignDialog();
    },
    cancelAddQue() {
      this.deleteSpecificAction();
      this.toggleSubmitAssignDialog();
      this.deviceDestination = this.initDeviceDestination;
    },
    finaliseQue() {
      this.highlightTargetEntities();
      this.toggleSubmitAssignDialog();
    },
    closeWindow() {
      this.$emit('closeDeviceAssignment');
      this.deviceDestination = this.initDeviceDestination;
      this.actionsQue = [];
      

      logger.info('init destination : ', this.deviceDestination)
    },
    async setSelectedOrg(org) {
      this.selectedOrg = org;

      const nodes = await GetOrgTree(this.selectedOrg.id);

      this.nodes = nodes.root_node;
    },
    deviceSelectedForInstall(data) {
      this.devicesForInstallation = data;
      this.$emit('deviceSelectedForInstall', data);
    },
    handleDMSelection(data) {
      if (data.length <= 0) {
        logger.info('data is empty : ', data)
        // this.deviceDestination = this.initDeviceDestination;

        return;
      }

      this.deviceDestination = data;

      if (!data[0].dir && this.devicesForInstallation.length > 1) {
        window.EventBus.$emit("resetDeviceSelection");
      }
    },
    removeInstallTag() {
      for(var i = 0; i < this.devicesForInstallation.length; i++) {
        let index = this.devicesForInstallation[i];

        this.selectedDevices.splice(index, 1);
      }
    },
    clearQue() {
      this.actionsQue = [];
    },
    addToQue() {
      let action = {
        devices: [],
        target: this.deviceDestination
      };

      for (let i = 0; i < this.devicesForInstallation.length; i++) {
        let index = this.devicesForInstallation[i];
        let device = this.selectedDevices[index];

        device.name = device.install_tag;
        device.icon = 'car';

        action.devices.push(device);

      }      

      this.actionsQue.push(action);
      this.removeInstallTag();
      // reset selection on left panel
      this.devicesForInstallation = [];
      window.EventBus.$emit("resetDeviceSelection");
      
    },
    deleteWrapper() {
      this.highlightTargetEntities();
      this.deleteSpecificAction();
    },
    deleteSpecificAction() {
      let target = this.actionsQue.find(item => {
        return item.target[0].id == this.deviceDestination[0].id
      });

      for(var i = 0; i < this.actionsQue.length; i++) {
        if(this.actionsQue[i].target[0].id == target.target[0].id) {
            // Send the install tags back to their list
            this.actionsQue[i].devices.forEach(device => {
              logger.info(device)
              this.selectedDevices.push(device);
            });
            this.actionsQue.splice(i, 1);

            break;
        }
      }
    },
    deleteLastAction() {
      this.highlightTargetEntities();
      
      let actionsTotal = this.actionsQue.length > 0 ? this.actionsQue.length - 1 : 0;
      let lastAction = this.actionsQue[actionsTotal];

      // Send the install tags back to their list
      lastAction.devices.forEach(device => {
        this.selectedDevices.push(device);
      });
      this.actionsQue.splice(-1);
    },
    resetActions() {
      window.EventBus.$emit('treeUpdated');
      this.$emit('refresh');
    },
    toggleStatus() {
      this.showStatus = !this.showStatus;
    },
    closeAllAssignmentWindows() {
      this.toggleStatus();
      this.$emit('closeAllAssignmentWindows');
    },
    handleUpdatedVehicleName(data) {
      this.actionsQue.forEach(action => {
        action.devices.forEach(device => {
          
          if (device.id == data.id) {
            device.updatedVehicleName = data.name;
          }
    
        });
      });
    },
    highlightTargetEntities() {
      let total = this.actionsQue.length > 0 ? this.actionsQue.length : 1;
      let latest = [this.actionsQue[total - 1]];

      window.EventBus.$emit('targetsForAssignment', latest);
    }
  }
}
</script>

<style lang="scss" scoped>
  .assignment-manager-container {
    z-index: 9998;
    position: fixed;
    left: 0%;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4) !important;
    width: 100vw;
    height: 100vh;
    .assignment-manager {
      background: white;
      margin: 0;
      position: relative;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 0;
      overflow: hidden;
      border: solid 2px;
      width: 1000px;
      .header {
        background: #e0e0e0;
        border: solid 1px;
        text-align: center;
        padding: 0;
      }
      .org-select {
        padding-left: 1em;
      }
      .ctrl-btn {
        font-size: 20px;
        padding-bottom: .25em;
        padding-bottom: .25em;
        color: #0069bb;
        &:hover {
          cursor: pointer;
        }
      }
      .cancel {
        padding-left: 1em;
      }
      .submit {
        padding-right: 1em;
      }
    }
    .close-icon {
      top: 0;
      right: 0;
      position: absolute;
    }
  }
</style>